import Repository from '@/repositories/marketing'
const resource = '/custom_row_categories'

export default {
  get (config) {
    return Repository.get(`${resource}`, config)
  },
  add (payload,config) {
    return Repository.post(`${resource}`, payload,config)
  },
  delete (config) {
    return Repository.delete(`${resource}/bulk_delete`, config)
  },
}
